// eslint-disable-next-line no-shadow
enum ActionType {
    CALLBACK = "callback", // appel une fonction et retourne le resultat
    ERROR = "error", // action a faire en cas d'erreurs dans l'exec des actions
    ROUTING = "routing", // changement de page
    REFRESH = "refresh", // refresh composant / page
    CONDITION = "condition", // action contionnelle
    CONFIG = "config", // mise à jour de la config d'un composant
}
export default ActionType
